import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { fmtNum } from "../../utils/format";
import { usePermissions } from "../../context/permissionContext";
import { validatePermission } from "../../utils/permissionUtils";

const buildItems = ({ campaignStats, userStats, paymentStatus }) => [
  {
    count: campaignStats?.in_initial_approval_campaign,
    label: "Initial review",
    sub: "campaigns awaiting first pass",
    to: "/initial-approve",
    requiredPermission: "Campaign - Initial Approval:View",
  },
  {
    count: campaignStats?.in_for_review_campaign,
    label: "Admin review",
    sub: "campaigns escalated for review",
    to: "/for-review-campaign",
    requiredPermission: "Campaign - For Review:View",
  },
  {
    count: userStats?.pending_accredited_investor_count,
    label: "Pending accreditation",
    sub: "manual verify",
    to: "/accredited-investors",
    requiredPermission: "Accredited Investors:View",
  },
  {
    count: userStats?.pending_kyc_count,
    label: "Pending KYC",
    sub: "auto-flagged",
    to: "/users",
    requiredPermission: "Users Management - Users:View",
  },
  {
    count: paymentStatus?.failed_transactions,
    label: "Failed payments",
    sub: "ACH + cards",
    to: "/transaction",
    requiredPermission: "Funds Management - Transaction:View",
  },
  {
    count: campaignStats?.closed_campaign,
    label: "Closed campaigns",
    sub: "review for archive",
    to: "/closed-campaign",
    requiredPermission: "Campaign - Closed Campaigns:View",
  },
];

const QueueRow = ({ count, label, sub, to }) => {
  const n = Number(count || 0);
  return (
    <Link className="q-row" to={to}>
      <span className={"q-count" + (n === 0 ? " q-count--zero" : "")}>{fmtNum(n)}</span>
      <div>
        <div className="q-label">{label}</div>
        <div className="q-sub"><span>{sub}</span></div>
      </div>
      <span className="q-cta">REVIEW <ChevronRight /></span>
    </Link>
  );
};

const QueuePanel = (props) => {
  const { permissions, permissionsMapping, loading } = usePermissions();
  const allItems = buildItems(props);
  const items = loading
    ? allItems
    : allItems.filter(
        (i) =>
          !i.requiredPermission ||
          validatePermission(i.requiredPermission, permissions, permissionsMapping)
      );
  const totalOpen = items.reduce((s, i) => s + Number(i.count || 0), 0);

  return (
    <section className="card">
      <header className="card__head">
        <h2 className="card__title">Your queue</h2>
        <span className="card__sub">{fmtNum(totalOpen)} open</span>
        <div className="card__head-right">
          <Link className="btn-link" to="/review-hub">Review hub <ChevronRight /></Link>
        </div>
      </header>
      <div className="card__body card__body--flush">
        {items.map((i) => <QueueRow key={i.to} {...i} />)}
      </div>
    </section>
  );
};

export default QueuePanel;
